export default "__VITE_ASSET__nozB4T8O__"